<template>
	<div>
		<!-- v-model:file-list="model" -->
		<el-upload
			ref="upload"
			:action="uploadURL"
			:multiple="is_multi"
			:headers="header"
			:limit="limit"
			v-model:file-list="model"
			drag
			accept="image/*"
			list-type="picture-card"
			:on-exceed="handleExceed"
			:on-success="success"
			:on-remove="handleRemove"
			:before-upload="beforeUpload"
			:on-preview="handlePictureCardPreview"
			:class="{ hideU: model.length > 0 }"
		>
			<div class="el-upload__text">点击选择文件或拖拽到此处</div>

			<el-icon class="avatar-uploader-icon"><Plus /></el-icon>
		</el-upload>
	</div>

	<!-- 图片预览 -->
	<el-image-viewer
		v-if="showImagePreview"
		:zoom-rate="1.2"
		@close="closePreview"
		:url-list="previewList"
	/>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import { ElMessage } from 'element-plus'
import cfg from '@/config/config.js'

// const uploadURL = cfg.HOST + '/form/upload'
const uploadURL = cfg.HOST + '/upload'
const header = ref({ Authorization: localStorage.getItem(cfg.TOKEN) })
const model = defineModel({ type: Array, default: [] })

const limit = ref(1)
const is_multi = ref(false)
const upload = ref()
const showImagePreview = ref(false)
const stopUpload = ref(false)
const previewList = ref([])

//上传之前回调
const beforeUpload = (e) => {
	const allowedFileTypes = [
		'image/jpeg', // JPEG 图像文件
		'image/png' // PNG 图像文件
	]
	// 获取文件的类型
	const fileType = e.type
	if (!allowedFileTypes.includes(fileType)) {
		stopUpload.value = true
		ElMessage({
			type: 'error',
			message: '上传格式错误'
		})
		return false // 阻止文件上传
	}
}

//成功之后回调
const success = (e) => {
	model.value = [
		{
			url: e.data.url
		}
	]
}
const handleRemove = (e) => {
	model.value = []
	previewList.value = []
}
const handleExceed = (files) => {
	upload.value.clearFiles()
	upload.value.handleStart(files[0])
	upload.value.submit()
}
/**
 * 预览
 * @param file
 */
function handlePictureCardPreview(file) {
	previewList.value = []
	previewList.value.push(file.url)
	showImagePreview.value = true
}
const closePreview = () => {
	showImagePreview.value = false
}
onMounted(() => {})

onUnmounted(() => {})
</script>

<style scoped lang="scss">
// .el-upload--picture-card 控制加号部分
:deep(.hideU .el-upload--picture-card) {
	display: none;
}
/* 新增：优化拖拽上传区域样式 */
:deep(.el-upload-dragger) {
	/* border: 2px dashed #d9d9d9; */
	padding: 0;
	border-radius: 8px;
	background: #fafbfc;
	transition: border-color 0.3s, background 0.3s;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	color: #909399;
	font-size: 12px;
}
:deep(.el-upload-dragger.is-dragover) {
	border-color: #409eff;
	background: #e6f7ff;
	color: #409eff;
}
:deep(.el-upload__text) {
	font-size: 14px;
	color: #606266;
	text-align: center;
	width: 100%;
	margin: 0;
	padding: 0;
}
</style>
